module.exports = __webpack_public_path__ + "assets/img/b0b1f9ea48964c4064dd8d773fb4851c.svg";